<template>
  <div class="bg-white h-auto flex flex-col rounded-md px-4 py-3">
    <!-- tab -->
    <div
      class="bg-[#fff] relative flex items-center my-4 rounded-lg px-2 py-3 gap-2 min-h-16 border-2 text-sm font-semibold border-b-gray-300 overflow-x-auto overflow-y-hidden"
    >
      <div class="flex flex-row gap-2">
        <div
          @click="filterCustomer('1')"
          :class="
            page == '1'
              ? 'bg-primary-light outline outline-primary outline-2 text-primary'
              : 'flex flex-row items-center text-nowrap text-sm font-semibold'
          "
          class="flex flex-row items-center text-nowrap text-sm font-semibold hover:bg-primary-light hover:outline outline-primary outline-2 hover:text-primary py-2 rounded-md cursor-pointer"
        >
          <span class="mx-3">{{ $t("Pos.All") }}</span>
        </div>

        <div
          @click="filterCustomer('2')"
          :class="
            page == '2'
              ? 'bg-primary-light outline outline-primary outline-2 text-primary'
              : 'flex flex-row items-center text-nowrap text-sm font-semibold'
          "
          class="flex flex-row items-center text-nowrap text-sm font-semibold hover:bg-primary-light hover:outline outline-primary outline-2 hover:text-primary py-2 rounded-md cursor-pointer"
        >
          <span class="mx-3">{{ $t("Pos.TodaysBirthday") }}</span>
        </div>
      </div>
    </div>
    <!-- tab  -->

    <a-row :gutter="[16, 16]" v-if="page == '1'">
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 16 }"
        :lg="{ span: 16 }"
        :xl="{ span: 16 }"
        :xxl="{ span: 16 }"
      >
        <div class="flex px-2 py-3 border-b-2 border-b-gray-200">

          <div class="max-w-fit my-auto">
            <iconSearchV2 :size="20" :color="'#000'" />
          </div>
          <input
            id="searchBarCustomer"
            @click="selectInput"
            @input="searchCustomers"
            type="text"
            class="w-[25rem] mx-2 focus:outline-none text-md"
            :placeholder="$t('Pos.FilterCustomerTxt')"
          />
        </div>
      </a-col>
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 8 }"
        :lg="{ span: 8 }"
        :xl="{ span: 8 }"
        :xxl="{ span: 8 }"
        class="display-container"
      >
        <a-date-picker
          :placeholder="$t('Pos.BirthDate')"
          v-model:value="birth_date"
          class="date-picker"
          @change="searchByBirthDate"
          format="DD-MMMM"
        ></a-date-picker>
      </a-col>
    </a-row>

    <!-- <div>
      <div class="flex px-2 py-3 border-b-2 border-b-gray-200">
        <div class="max-w-fit my-auto">
          <iconSearchV2 :size="20" :color="'#000'" />
        </div>
        <input
          id="searchBarCustomer"
          @click="selectInput"
          @input="searchCustomers"
          type="text"
          class="w-[25rem] mx-2 focus:outline-none text-md"
          :placeholder="$t('Pos.SearchCustomers')"
        />
      </div>
      <a-date-picker
        :placeholder="$t('Pos.BirthDate')"
        v-model:value="birth_date"
        class="date-picker"
      ></a-date-picker>
    </div> -->

    <a-row
      v-if="selectedCustomer.id && page == '1'"
      class="flex justify-between my-4"
    >
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 20 }"
        :lg="{ span: 20 }"
        :xl="{ span: 20 }"
        :xxl="{ span: 20 }"
        class="flex"
      >
        <a-row>
          <a-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :lg="{ span: 24 }"
            :xl="{ span: 24 }"
            :xxl="{ span: 24 }"
            class="flex flex-row gap-2"
          >
            <div>
              <img
                :src="
                  selectedCustomer.photo
                    ? selectedCustomer.photo
                    : '/default_img.jpg'
                "
                class="rounded-xl w-28"
                alt=""
              />
            </div>
            <div class="flex flex-col font-semibold justify-between mx-4">
              <div>
                <div class="flex gap-4 items-baseline">
                  <span class="text-3xl">{{
                    selectedCustomer.first_name +
                    " " +
                    selectedCustomer.last_name
                  }}</span>
                  <span></span>
                </div>
                <div class="flex flex-col items-start opacity-40">
                  <span>{{ selectedCustomer.email }}</span>
                  <span>{{ selectedCustomer.phone }}</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :lg="{ span: 24 }"
            :xl="{ span: 24 }"
            :xxl="{ span: 24 }"
            class="flex flex-row gap-2 mt-2"
          >
            <a-row>
              <a-col
                :xs="{ span: 12 }"
                :sm="{ span: 12 }"
                :md="{ span: 5 }"
                :lg="{ span: 5 }"
                :xl="{ span: 5 }"
                :xxl="{ span: 5 }"
              >
                <a-button
                  @click="navigateUpdateCustomer"
                  type="text"
                  style="display: flex; align-items: start; font-size: 16px"
                >
                  <template #icon>
                    <EditOutlined :style="{ fontSize: '20px' }" />
                  </template>
                  {{ $t("Pos.Edit") }}
                </a-button>
              </a-col>
              <a-col
                :xs="{ span: 12 }"
                :sm="{ span: 12 }"
                :md="{ span: 5 }"
                :lg="{ span: 5 }"
                :xl="{ span: 5 }"
                :xxl="{ span: 5 }"
                v-if="userRole == 'super_admin' || userRole == 'Manager' || userRole == 'Admin'"
              >
                <a-button
                  @click="deleteCustomer"
                  type="text"
                  style="display: flex; align-items: start; font-size: 16px"
                >
                  <template #icon>
                    <DeleteOutlined :style="{ fontSize: '20px' }" />
                  </template>
                  {{ $t("Pos.Delete") }}
                </a-button>
              </a-col>
              <a-col
                :xs="{ span: 12 }"
                :sm="{ span: 12 }"
                :md="{ span: 7 }"
                :lg="{ span: 7 }"
                :xl="{ span: 7 }"
                :xxl="{ span: 7 }"
              >
                <a-button
                  @click="handleInfo('sales')"
                  type="text"
                  style="display: flex; align-items: center; font-size: 16px"
                >
                  <template #icon>
                    <DollarCircleOutlined :style="{ fontSize: '20px' }" />
                  </template>
                  {{
                    showSalesCustomer && !showLoyaltyCustomer
                      ? $t("Pos.ShowSales")
                      : $t("Pos.ShowSales")
                  }}
                </a-button>
              </a-col>
              <a-col
                :xs="{ span: 12 }"
                :sm="{ span: 12 }"
                :md="{ span: 7 }"
                :lg="{ span: 7 }"
                :xl="{ span: 7 }"
                :xxl="{ span: 7 }"
              >
                <a-button
                  @click="handleInfo('loaylty')"
                  type="text"
                  style="display: flex; align-items: center; font-size: 16px"
                >
                  <template #icon>
                    <SketchOutlined :style="{ fontSize: '20px' }" />
                  </template>
                  {{
                    showLoyaltyCustomer && !showSalesCustomer
                      ? $t("Pos.ShowLoyaltyPoints")
                      : $t("Pos.ShowLoyaltyPoints")
                  }}
                </a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 4 }"
        :lg="{ span: 4 }"
        :xl="{ span: 4 }"
        :xxl="{ span: 4 }"
        class="flex flex-col gap-2 justify-between items-end"
      >
        <a-button
          v-if="showSalesCustomer || showLoyaltyCustomer"
          @click="handleInfo('return')"
          class="flex flex-row items-center gap-1 font-semibold border-2 border-gray-700 text-gray-700 w-full"
        >
          <ArrowLeftOutlined />
          {{ $t("Pos.Return") }}
        </a-button>
        <a-button
          @click="chooseCustomer"
          class="text-primary border-primary font-semibold border-2 w-full"
          >{{ $t("Pos.Select") }}</a-button
        >
      </a-col>
    </a-row>
    <span
      v-if="!showSalesCustomer && !showLoyaltyCustomer && page == '1'"
      class="flex text-2xl font-semibold my-6"
      >{{ $t("Pos.RecentCustomers") }}</span
    >
    <span
      v-if="!showSalesCustomer && !showLoyaltyCustomer && page == '2'"
      class="flex text-2xl font-semibold my-6"
      >{{ $t("Pos.TodaysBirthday") }}</span
    >

    <span
      v-if="showSalesCustomer && !showLoyaltyCustomer && page == '1'"
      class="flex text-2xl font-semibold my-6"
      >{{ $t("Pos.CustomerSales") }}</span
    >

    <!-- customer list -->
    <div
      v-if="!showSalesCustomer && !showLoyaltyCustomer && page == '1'"
      class="overflow-auto flex-grow"
    >
      <a-list
        :loading="loadingCustomers"
        item-layout="horizontal"
        :data-source="customers"
        :split="false"
      >
        <template #renderItem="{ item, index }">
          <a-list-item
            class="text-left rounded-md text-white"
            :style="getListStyle(index, item)"
            @click="selectCustomer(item)"
          >
            <a-skeleton avatar :title="false" :loading="!!item.loading" active>
              <a-list-item-meta :description="item.phone">
                <template #title>
                  <span>{{ item.first_name + " " + item.last_name }}</span>
                </template>

                <template #avatar>
                  <img
                    :src="item.img ? item.img : '/default_img.jpg'"
                    style="width: 50px"
                    class="rounded-md"
                  />
                </template>
              </a-list-item-meta>
              <div class="font-semibold">{{ formatDate(item.birthday) }}</div>
            </a-skeleton>
          </a-list-item>
        </template>
      </a-list>
      <div class="flex justify-end">
        <a-pagination
          class="paginationArrows"
          v-model:current="currentPageValue"
          :pageSize="perPage"
          :total="totalPages"
          :default-page-size="perPage"
          :showSizeChanger="false"
          @change="handlePageChange"
        />
      </div>
    </div>

    <!-- customers birthday -->
    <div v-if="page == '2'" class="overflow-auto flex-grow">
      <a-list
        :loading="loadingCustomers"
        item-layout="horizontal"
        :data-source="customers"
        :split="false"
      >
        <template #renderItem="{ item, index }">
          <a-list-item
            class="text-left rounded-md text-white"
            :style="getListStyle(index, item)"
            @click="selectCustomer(item)"
          >
            <a-skeleton avatar :title="false" :loading="!!item.loading" active>
              <a-list-item-meta :description="item.phone">
                <template #title>
                  <span>{{ item.first_name + " " + item.last_name }}</span>
                </template>

                <template #avatar>
                  <img
                    :src="item.img ? item.img : '/default_img.jpg'"
                    style="width: 50px"
                    class="rounded-md"
                  />
                </template>
              </a-list-item-meta>
              <div class="font-semibold">{{ formatDate(item.birthday) }}</div>
            </a-skeleton>
          </a-list-item>
        </template>
      </a-list>
      <div class="flex justify-end">
        <a-pagination
          class="paginationArrows"
          v-model:current="currentPageValue"
          :pageSize="perPage"
          :total="totalPages"
          :default-page-size="perPage"
          :showSizeChanger="false"
          @change="handlePageBirthdayChange"
        />
      </div>
    </div>

    <!-- loaylty -->
    <div v-if="showLoyaltyCustomer && !showSalesCustomer && page == '1'">
      <span class="flex text-2xl font-semibold my-6">{{
        $t("Pos.CustomerLoyalty")
      }}</span>
      <a-spin v-if="loadingLoyalty" :spinning="loadingLoyalty"></a-spin>
      <div v-else>
        <a-table
          class="ant-table-striped"
          size="middle"
          :columns="loyaltyColumns"
          :data-source="customerLoyalty"
          :pagination="false"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'item'">
              <span>{{ record.loyalty_setting.product.name }}</span>
            </template>
            <template v-if="column.dataIndex === 'quantity'">
              <template v-for="i in record.purchased_quantity" :key="i">
                <span class="text-2xl mx-1">*</span>
              </template>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <!-- customer sales -->
    <div v-if="showSalesCustomer && !showLoyaltyCustomer && page == '1'">
      <a-spin v-if="loadingCsSales" :spinning="loadingCsSales"></a-spin>
      <a-table
        v-else
        class="ant-table-striped"
        size="middle"
        :columns="columns"
        :data-source="selectedCustomer.sales"
        :row-class-name="
          (_record, index) => (index % 2 === 1 ? 'table-striped' : null)
        "
        :pagination="false"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'options'">
            <a-button
              class="view-btn text-primary border-primary"
              @click="() => showSale(record)"
            >
              <template #icon>
                <EyeOutlined />
              </template>
            </a-button>
          </template>
          <template v-if="column.dataIndex === 'is_paid'">
            <div class="flex flex-row">
              <a>{{ text == 1 ? $t("Pos.Paid") : $t("Pos.NotPaid") }}</a>
              <div
                v-if="record.is_offer == 1 && record.is_paid == 0"
                class="flex flex-row"
              >
                <span class="mx-1">-</span>
                <div class="flex items-center flex-row gap-2">
                  <span>{{ $t("Pos.Offer") }}</span>
                  <iconBadge :size="20" :color="'#FFC94A'" />
                </div>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'created_at'">
            <a>{{ formatDateTime(record.created_at) }}</a>
          </template>

          <template v-if="column.dataIndex === 'total'">
            <a>{{
              formatAmount(record.total, currencyCode, decimalPrecision)
            }}</a>
          </template>
        </template>
      </a-table>
    </div>
    <LbrxKeyboardPopup
      :active="modalKeyboard.active"
      @closePopupKeyboard="closePopupKeyboard"
    />
  </div>
</template>


<script>
import iconSearchV2 from "./icons/iconSearchV2.vue";
import {
  EditOutlined,
  DollarCircleOutlined,
  SketchOutlined,
  EyeOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
} from "@ant-design/icons-vue";
import moment from "moment/moment";
import router from "@/router";
import LbrxKeyboardPopup from "./LbrxKeyboardPopup.vue";
import { currency } from "@/_helpers";
import dayjs from "dayjs";
import iconBadge from "./icons/iconBadge.vue";
import Swal from "sweetalert2";

export default {
  name: "LbrxListCustomers",
  components: {
    EditOutlined,
    DollarCircleOutlined,
    iconSearchV2,
    LbrxKeyboardPopup,
    iconBadge,
    SketchOutlined,
    EyeOutlined,
    ArrowLeftOutlined,
    DeleteOutlined,
  },
  props: {
    userRole: {
      required: true,
      value: String,
    },
    loadingCsSales: {
      required: true,
      value: Boolean,
    },
    loadingCustomers: {
      required: true,
      value: Boolean,
    },
    currentPage: {
      required: true,
      value: Number,
    },
    perPage: {
      required: true,
      value: Number,
    },
    totalPages: {
      required: true,
      value: Number,
    },
    customers: {
      required: true,
      value: Array,
    },
    selectedCustomer: {
      required: true,
      value: Object,
    },
    searchInputModel: {
      required: true,
      value: String,
    },
    showSalesCustomer: {
      required: true,
      value: Boolean,
    },
    posConfig: {
      required: true,
      value: Object,
    },
    currencyCode: {
      required: false,
      value: String,
    },
    decimalPrecision: {
      required: false,
      value: Number,
      default: 3,
    },
    customerLoyalty: {
      required: false,
      value: Array,
      default: [],
    },
    loadingLoyalty: {
      required: false,
      value: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: "1",
      data: [
        {
          img: "/profile_img.jpg",
          name: "oussema oussema",
          email: "oussema@liberrex.com",
          created_at: "16/02/2020",
        },
        {
          img: "/profile_img.jpg",
          name: "oussema oussema",
          email: "oussema@liberrex.com",
          created_at: "16/02/2020",
        },
        {
          img: "/profile_img.jpg",
          name: "oussema oussema",
          email: "oussema@liberrex.com",
          created_at: "16/02/2020",
        },
        {
          img: "/profile_img.jpg",
          name: "oussema oussema",
          email: "oussema@liberrex.com",
          created_at: "16/02/2020",
        },
        {
          img: "/profile_img.jpg",
          name: "oussema oussema",
          email: "oussema@liberrex.com",
          created_at: "16/02/2020",
        },
        {
          img: "/profile_img.jpg",
          name: "oussema oussema",
          email: "oussema@liberrex.com",
          created_at: "16/02/2020",
        },
        {
          img: "/profile_img.jpg",
          name: "oussema oussema",
          email: "oussema@liberrex.com",
          created_at: "16/02/2020",
        },
      ],
      columns: [
        {
          title: this.$t("Pos.Status"),
          dataIndex: "is_paid",
        },
        {
          title: this.$t("Pos.Date"),
          dataIndex: "created_at",
        },
        {
          title: this.$t("Pos.TotalPrice"),
          dataIndex: "total",
        },
        {
          title: "",
          dataIndex: "options",
        },
      ],
      loyaltyColumns: [
        {
          title: this.$t("Pos.Item"),
          dataIndex: "item",
        },
        {
          title: this.$t("Pos.PointsEarned"),
          dataIndex: "quantity",
        },
      ],
      timer: null,
      modalKeyboard: {
        active: false,
      },
      birth_date: "",
      localCurrentPage: 1,
      showLoyaltyCustomer: false,
    };
  },
  computed: {
    currentPageValue: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.localCurrentPage = value;
        this.$emit("update:currentPage", value);
      },
    },
  },
  methods: {
    deleteCustomer() {
      document.documentElement.style.setProperty(
        "--swal2-actions-bg",
        this.posConfig?.store?.primaryColor || "#fc8019"
      );
      Swal.fire({
        title: this.$t("Pos.DeleteCustomerTitle"),
        text: this.$t("Pos.DeleteCustomerText"),
        icon: "warning",
        confirmButtonText: this.$t("Pos.Delete"),
        confirmButtonColor: this.posConfig?.store?.primaryColor || "#fc8019",
        customClass: {
          popup: "swal2-popup",
          confirmButton: "swal2-confirm",
        },
        showCancelButton: true,
        cancelButtonText: this.$t("Pos.Cancel"),
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("deleteCustomer", this.selectedCustomer.id);
        }
      });
    },
    showLoyalty() {
      this.$emit("showLoyalty");
    },
    getDivStyle() {
      return this.fitWidth ? "flex gap-2" : "absolute flex gap-2";
    },
    formatDateTime(date) {
      if (date == null) return "";
      //format date to dd/mm/yyyy hh:mm
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    formatAmount(amount, currencyCode, decimalPrecision) {
      return currency.formatAmount(amount, currencyCode, decimalPrecision);
    },
    getListStyle(index, item) {
      return {
        backgroundColor:
          this.selectedCustomer.id == item.id
            ? JSON.parse(localStorage.getItem("themeTemplate")).primaryLight
            : index % 2 == 0
            ? "#f5f5f5"
            : "",
      };
    },
    formatDate(date) {
      if (date == null) return "";
      return moment(date).format("DD/MM/YYYY");
    },

    showSales() {
      this.$emit("showSales");
    },
    selectCustomer(customer) {
      this.$emit("selectCustomer", customer);
    },
    chooseCustomer() {
      this.$emit("chooseCustomer");
    },
    searchCustomers(event) {
      
      clearTimeout(this.timer); // Clear previous timer
      this.timer = setTimeout(() => {
        const inputValue = event.target.value;
        this.$emit("searchCustomers", inputValue);
      }, 500);
    },
    navigateUpdateCustomer() {
      router.push("/customer/" + this.selectedCustomer.id + "/update");
    },
    selectInput() {
      if (this.posConfig.posConfig.showKeyboard == 1) {
        this.modalKeyboard.active = true;
      }
    },
    closePopupKeyboard(text) {
      const inputValue = document.getElementById("searchBarCustomer");
      inputValue.value = text;
      this.$emit("searchCustomers", inputValue.value);
      this.modalKeyboard.active = false;
    },
    searchByBirthDate() {
      if (this.birth_date) {
        const birthDate = dayjs(this.birth_date).format("MM-DD");
        this.$emit("searchByBirthDate", birthDate);
      } else {
        this.$emit("resetFilter");
      }
    },
    handlePageChange(page, pageSize) {
      this.currentPageValue = page;
      this.$emit("handlePageChange", page, pageSize);
    },
    handlePageBirthdayChange(page, pageSize) {
      const birthDate = dayjs().format("MM-DD");
      this.currentPageValue = page;
      this.$emit("handlePageBirthdayChange", birthDate, page, pageSize);
    },
    filterCustomer(type) {
      this.page = type;
      this.$emit("filterCustomer", type);
    },
    showSale(record) {
      this.$emit("openSale", record);
    },
    handleInfo(info) {
      //console.log("info :)", info);
      if (info == "loaylty") {
        this.showLoyaltyCustomer = true;
        this.$emit("handleShowSalesCustomer", false);
        this.showLoyalty();
      }
      if (info == "sales") {
        this.showLoyaltyCustomer = false;
        this.$emit("handleShowSalesCustomer", true);
        this.$emit("showCustomerSales");
      }
      if (info == "return") {
        this.showLoyaltyCustomer = false;
        this.$emit("handleShowSalesCustomer", false);
        this.page = "1";
        //console.log("page :)", this.page);
      }
    },
  },
};
</script>

<style scoped>
.date-picker {
  border: 2px solid #e5e7eb;
  padding: 8px;
  border-radius: 5px;
  width: 100% !important;
}

.display-container {
  display: flex;
  justify-content: flex-end !important;
}

.view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
